import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { map } from 'lodash';

@Component({
  selector: 'ra-ordered-list-drag-drop',
  templateUrl: './ordered-list-drag-drop.component.html',
  styleUrls: ['./ordered-list-drag-drop.component.scss'],
  standalone: false,
})
export class OrderedListDragDropComponent implements OnInit {
  @Input() list: any[];
  @Input() allValues: any[];
  @Input() id: string;
  @Input() label: string;
  @Input() topDirectionText: string;
  @Input() bottomDirectionText: string;
  @Input() topDirectionColor: string;
  @Input() bottomDirectionColor: string;
  @Output() orderChanged = new EventEmitter();
  @Input() styles;
  defaultStyles = {
    width: '250px',
    'min-height': '45px',
    'max-height': '600px',
  };
  allValuesMap = {};

  constructor() {}

  ngOnInit() {
    this.allValuesMap = this.allValues?.reduce((prev, curr) => {
      prev[curr?.[this.id]] = curr?.[this.label];
      return prev;
    }, {});
  }

  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.list, event.previousIndex, event.currentIndex);
    this.emitOrderedValues();
  }

  getStyle() {
    return {
      'background-image':
        this.topDirectionColor && this.bottomDirectionColor
          ? `linear-gradient(${this.topDirectionColor}, ${this.bottomDirectionColor})`
          : 'initial',
    };
  }

  emitOrderedValues() {
    const orderedValues = this.id ? map(this.list, this.id) : this.list;
    this.orderChanged.emit(orderedValues);
  }
}
